
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-edit_note",
  "use": "icon-material-edit_note-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-edit_note\"><path d=\"M154.02-396.85v-68.13h310.76v68.13zm0-170.5v-68.13h478.13v68.13zm0-170.5v-68.37h478.13v68.37zm365.02 583.83v-128.02L741-503q9.51-9.63 21.13-13.91 11.62-4.29 23.5-4.29 12.48 0 24.21 4.86T831.02-502l37 37q9.44 9.48 13.82 21.12 4.38 11.63 4.38 23.27 0 11.96-4.86 24.06-4.86 12.09-14.25 21.57L647.07-154.02zm303.59-266.59-37-37zm-240 203h38l120.28-121.23-18-19.02-19-18.03-121.28 120.22zm140.28-140.28-19-18 37 37z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-edit_note"/>
                </svg>
            );
        };

        Icon.id = "icon-material-edit_note";

        export default Icon;
    